<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="临时产品编码" prop="productCodeTemp">
            <el-input v-model.trim="searchForm.productCodeTemp" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="临时产品名称" prop="productNameTemp">
            <el-input v-model.trim="searchForm.productNameTemp" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="正式产品编码" prop="productCode">
            <el-input v-model.trim="searchForm.productCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="正式产品名称" prop="description">
            <el-input v-model.trim="searchForm.description" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="是否替换" prop="replace">
            <el-select v-model="searchForm.replace" clearable @change="onSearch">
              <el-option label="是" value="是" />
              <el-option label="否" value="否" />
            </el-select>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column label="临时产品编码" prop="productCodeTemp" min-width="120"> </el-table-column>
        <el-table-column label="临时产品名称" prop="productNameTemp" min-width="160"> </el-table-column>
        <el-table-column label="导入时间" prop="creationDate" min-width="140"> </el-table-column>
        <el-table-column label="导入人" prop="importName" min-width="80"> </el-table-column>
        <el-table-column label="是否替换" prop="replace" min-width="80"> </el-table-column>
        <el-table-column label="正式产品编码" prop="productCode" min-width="120"> </el-table-column>
        <el-table-column label="正式产品名称" prop="description" min-width="160"> </el-table-column>
        <el-table-column label="替换时间" prop="lastUpdateDate" min-width="140"> </el-table-column>
        <el-table-column label="替换人" prop="replaceName" min-width="80"> </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
import axios from '@/utils/axiosInstance';
import { downloadFile } from '@/utils';
import moment from 'moment';
export default {
  name: 'TemporaryProductDataSheet',
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      loading: false,
      searchForm: {
        productCodeTemp: '',
        productNameTemp: '',
        productCode: '',
        description: '',
        replace: '',
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      backReasonList: [],
      goodsLocationList: [],
      productTypeList: [],
    };
  },
  computed: {},
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        filterData: this.searchForm
      };
      this.searchFormData = data;
      this.$q.newProduct.tempProductPage({data: data})
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-new',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'tempProduct',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
  mounted() {
    // this.getbackReasonList();
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped></style>
